import React, { FC, useEffect } from 'react'

import { StorageProvider } from '../../context/StorageContext/StorageProvider'
import { useFlowContext } from '../../hooks/useFlowContext'
import { monitoring } from '../../monitoring/appMonitoring'
import { AppInStorageProvider } from './AppInStorageProvider'

export const App: FC = () => {
  useEffect(() => {
    monitoring.appLoaded()
  }, [])

  const [flowContext] = useFlowContext()
  const flowId = flowContext?.historyEntries[0]?.flowId ?? 'preview' // TODO: think about it better :)

  return (
    <StorageProvider flowId={flowId}>
      <AppInStorageProvider />
    </StorageProvider>
  )
}
